import React, { useEffect, useState } from 'react';

import { Form, Formik } from 'formik';

import Editor from '@components/common/editor/Editor';
import { isLpcUrl } from '@services/utils/StringService';

import css from './Editor.module.scss';
import Custom404 from '../../404';

const EditorPage = () => {
    const [initialContent, setInitialContent] = useState<string>('');
    const [showEditor, setShowEditor] = useState<boolean>(null);

    useEffect(() => {
        if (
            typeof document !== 'undefined' &&
            (!isLpcUrl(document.referrer) ||
                (document.location.ancestorOrigins && !isLpcUrl(document.location.ancestorOrigins[0])))
        ) {
            setShowEditor(false);
        } else {
            setShowEditor(true);
        }
    }, []);

    if (typeof window !== 'undefined') {
        window.addEventListener('message', (event) => {
            if (
                isLpcUrl(document.referrer) &&
                ((document.location.ancestorOrigins && event.origin.startsWith(document.location.ancestorOrigins[0])) ||
                    document.referrer.startsWith(event.origin))
            ) {
                if (event.data && event.data.description) {
                    setInitialContent(event.data.description);
                }
            }
        });
    }

    const updateContent = (value) => {
        parent.postMessage({ description: value }, document.referrer);
    };

    return (
        <>
            {showEditor && initialContent && (
                <div className={css.editorPageWrapper}>
                    <Formik initialValues={{ description: initialContent }} onSubmit={() => {}}>
                        {() => (
                            <Form className={css.form}>
                                <Editor
                                    onUpdateContent={(str) => updateContent(str)}
                                    hasBlackIcons={true}
                                    customClass={css.editor}
                                    value={initialContent}
                                    editorImageUploadUrl={'pot'}
                                    editorPlaceholder={initialContent}
                                    editorId={'custom-editor'}
                                    editorName={'description'}
                                />
                            </Form>
                        )}
                    </Formik>
                </div>
            )}
            {showEditor === false && <Custom404 />}
        </>
    );
};
export default EditorPage;
